<template>
  <v-expansion-panel-content class="danger-expansion-panel">
    <template
      v-slot:header
      class="danger-expansion-panel__header"
    >
      <h6 class="title">
        <v-icon
          class="mr-2"
          style="color: red"
        >
          warning
        </v-icon>
        Danger Zone
      </h6>
    </template>
    <ul>
      <li class="box-row d-flex flex-items-center danger-item">
        <div>
          <strong>Decline the FP/Tranche</strong>
          <div>
            The FP/Tranche is declined. If a FP is declined, all included tranches are also declined
          </div>
        </div>
        <div>
          <v-btn
            class="danger-button"
            flat="flat"
            @click="toggleActionModalOpen('decline')"
          >
            Decline
          </v-btn>
        </div>
      </li>
      <li
        v-if="financialProduct.stage === 'published'"
        class="box-row d-flex flex-items-center danger-item"
      >
        <div>
          <strong>Close the FP/Tranche</strong>
          <div>
            The FP/Tranche is officially closed
          </div>
        </div>
        <div>
          <v-btn
            class="danger-button"
            flat="flat"
            @click="toggleActionModalOpen('close')"
          >
            Close
          </v-btn>
        </div>
      </li>
    </ul>
    <v-dialog
      v-model="modalActionOpen"
      width="400"
      persistent
    >
      <v-card>
        <v-card-title
          class="error"
        >
          <span class="white--text">
            Please confirm to {{ action }} - this cannot be undone!
          </span>
        </v-card-title>
        <v-alert
          v-if="error"
          type="error"
          :value="true"
        >
          {{ error }}
        </v-alert>
        <v-form
          @submit.prevent="submitAction"
        >
          <v-card-actions>
            <v-spacer />
            <v-btn
              flat
              @click="toggleActionModalOpen"
            >
              Close
            </v-btn>
            <Button
              flat
              type="submit"
              color="error"
              :text="action"
            />
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-expansion-panel-content>
</template>

<script>
import { Button } from '@/components/shared';
import StagesEnum from '../../enum/financialProducts/Stages';

export default {
  name: 'DangerZoneExpansionPanel',
  components: {
    Button,
  },
  props: {
    financialProduct: {
      type: Object,
      default: () => {},
    },
    declineAction: {
      type: Function,
      default: () => ({}),
    },
    closeAction: {
      type: Function,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: '',
      modalActionOpen: false,
      action: '',
    };
  },
  methods: {
    decline() {
      if (this.financialProduct.stage === StagesEnum.CLOSED) {
        this.error = 'It is not allowed to decline financial products in the "closed" stage';
      } else {
        this.declineAction();
        this.error = '';
        this.modalActionOpen = false;
      }
    },
    toggleActionModalOpen(action = '') {
      this.error = '';
      this.action = action;
      this.modalActionOpen = !this.modalActionOpen;
    },
    submitAction() {
      switch (this.action) {
        case 'decline':
          this.decline();
          break;
        case 'close':
          this.close();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
  .danger-expansion-panel {
    border: solid red !important;
  }
  .flex-items-center {
    align-items: center !important;
  }
  .danger-item {
    padding: 13px 13px 13px 24px;
    border-top: 0.1px solid lightgray;
  }
  .danger-button {
    border: 0.1px solid lightgray;
    min-width: 100px;
    min-height: 36px;
    border-radius: 5px;
    color: red;
    float: right;
  }
  .danger-button:hover {
    background-color: red;
    color: white !important;
    border-color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/financialProducts/DangerZoneExpansionPanel.vue